<template>
  <div class="add-new-client" v-if="campaign">
    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>
        <span>Delete brand</span>
        <button class="btn btn--close" @click="deleteDialog = false; showDialog = true"></button>
      </md-dialog-title>
      <div class="margin-auto">
        <span>Are you sure you want to delete the next:</span>
        <div class="textTitle margin-medium--top">
          <span class="margin-auto textTitlesilver">{{ campaign.name }}</span>
        </div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="cancel; showDialog = true; deleteDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteCampaign">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog :md-active.sync="showDialog">
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(saveCampaign)" class="form">
          <md-dialog-title>
            <span>Edit {{ campaign.name }}</span>
            <button class="btn btn--close" @click="cancel"></button>
          </md-dialog-title>
          <div class="form__content">
            <ValidationProvider :rules="{required :true, min:3}" v-slot="{ errors }" tag="div">
              <md-field>
                <label>Campaign name</label>
                <md-input v-model="campaign_name"/>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
          </div>
          <md-dialog-actions>
            <div class="md-layout">
              <div class="md-layout-item row">
                <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                <a class="hrefButton--black margin-medium--left" @click="deleteDialog = true; showDialog = false">Delete
                  Campaign</a>
              </div>
              <div class="md-layout-item text-right">
                <md-button class="md-primary modal-save-btn" type="submit">Save Campaign</md-button>
              </div>
            </div>
          </md-dialog-actions>
        </form>
      </validation-observer>
    </md-dialog>
    <div class="row">
      <button class="btn btn-edit " @click="showDialog = true">
        <img alt="Edit Button" src="@/assets/img/icons/edit.svg"> Edit campaign
      </button>
      <div v-if="campaign.board && campaign.board.length">
        <button v-if="!copyLinkAnim" @click="copyLink()" class="btn btn-edit--blue margin-medium--left copy-campaign-link">
          <img alt="Edit Button" src="@/assets/img/icons/clone.svg"> Copy campaign link
        </button>
        <div v-else class="animCopyLink btn btn-edit--blue margin-medium--left copy-campaign-link">              
          <div><img src="@/assets/img/icons/ic-blue-check.svg"></div>
        </div>
      </div>     
    </div>
  </div>
</template>


<script>
import apiHandlerMI from "@/mixins/apiHandlerMI.js";
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {min, required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';
import copyToClipboard from "@/utils/copyToClipboard";

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "Campaign name is required."
});
extend('min', {
  ...min,
  message: "This field should contain at least 3 letters"
});

export default {
  props: ['campaign', 'campaign_name'],
  mixins: [apiHandlerMI],
  data() {
    return {
      showDialog: false,
      deleteDialog: false,
      active: false,
      error: [],
      copyLinkAnim:false
    }
  },
  components: {
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    deleteCampaign() {
      const _this = this;
      this.delete(`campaign/${this.campaign.id}`, {}, () => {
        _this.showDialog = false;
        _this.deleteDialog = false;
        _this.$parent.refreshBrand();
      }, () => {
        console.log('Sikertelen Torles');
      });
    },
    copyLink() {
      const baseUrl = window.location.origin;
      copyToClipboard(`${baseUrl}/brand/${this.campaign.brand.slug}/${this.campaign.slug}/${this.campaign.board[0].slug}`);
      // alert('Campaign link was copied')
      this.copyLinkAnim = true
      let _this = this      
      setTimeout(() => {
        _this.copyLinkAnim = false
      }, 2000);
    },
    saveCampaign() {
      var _this = this;

      this.put('campaign/' + this.campaign.id, {name: this.campaign_name}, {}, function () {

        if (_this.$parent.refreshBrand)
          _this.$parent.refreshBrand();
        _this.showDialog = false
      }, function (resp) {
        //console.log(resp);
        _this.error = resp.data.error;
        this.$forceUpdate();
      })
    },

    cancel() {
      this.showDialog = false
      this.campaign_name = this.campaign.name;
    }
  }
}
</script>